import React, { useState } from 'react';
import {
  Container,
  Tabs,
  Tab,
  Card,
  Form,
  Row,
  Col,
  Button,
  Table,
} from 'react-bootstrap';
import {
  FaList,
  FaMapMarkerAlt,
  FaSitemap,
  FaCity,
  FaBriefcase,
  FaBuilding,
  FaGraduationCap,
  FaUserTie,
  FaEdit,
  FaTrash,
  FaUserFriends,
} from 'react-icons/fa';
import 'bootstrap/dist/css/bootstrap.min.css';

const AdminMasterPage = () => {
  const [activeTab, setActiveTab] = useState('category');
  const sections = [
    'Category',
    'Occupation',
    'Department',
    'Division',
    'Subdivision',
    'Designation',
    'Education',
   
  ];

  const [data, setData] = useState(
    sections.reduce((acc, section) => ({ ...acc, [section]: [] }), {})
  );

  const [inputValues, setInputValues] = useState(
    sections.reduce((acc, section) => ({ ...acc, [section]: '' }), {})
  );

  const [editIndices, setEditIndices] = useState(
    sections.reduce((acc, section) => ({ ...acc, [section]: null }), {})
  );

  const handleChange = (section, value) => {
    setInputValues({ ...inputValues, [section]: value });
  };

  const handleAdd = (section) => {
    const trimmed = inputValues[section].trim();
    if (!trimmed) return;

    const updatedData = [...data[section]];
    if (editIndices[section] !== null) {
      updatedData[editIndices[section]] = trimmed;
    } else {
      updatedData.push(trimmed);
    }

    setData({ ...data, [section]: updatedData });
    setInputValues({ ...inputValues, [section]: '' });
    setEditIndices({ ...editIndices, [section]: null });
  };

  const handleEdit = (section, index) => {
    setInputValues({ ...inputValues, [section]: data[section][index] });
    setEditIndices({ ...editIndices, [section]: index });
  };

  const handleDelete = (section, index) => {
    const updatedData = [...data[section]];
    updatedData.splice(index, 1);
    setData({ ...data, [section]: updatedData });
  };

  const icons = {
    Category: <FaList />,
    Occupation: <FaBriefcase />,
    Department: <FaBuilding />,
    Division: <FaMapMarkerAlt />,
    Subdivision: <FaSitemap />,
    Designation: <FaUserTie />,
    Education: <FaGraduationCap />,
    Deparment:<FaUserFriends />,
  };

  return (
    <Container className="py-4">
      <h3 className="text-center mb-4">Create Master Page</h3>
      <Card>
        <Card.Body>
          <Tabs
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
            className="mb-3"
            fill
          >
            {sections.map((section) => (
              <Tab
                eventKey={section.toLowerCase()}
                key={section}
                title={
                  <>
                    {icons[section]} {section}
                  </>
                }
              >
                <Form className="mb-3">
                  <Row>
                    <Col xs={8} sm={9}>
                      <Form.Control
                        type="text"
                        placeholder={`Enter ${section}`}
                        value={inputValues[section]}
                        onChange={(e) =>
                          handleChange(section, e.target.value)
                        }
                      />
                    </Col>
                    <Col xs={4} sm={3}>
                      <Button
                        onClick={() => handleAdd(section)}
                        variant="primary"
                        className="w-100"
                      >
                        {editIndices[section] !== null ? 'Update' : 'Add'}
                      </Button>
                    </Col>
                  </Row>
                </Form>

                <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>{section} Name</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data[section].length > 0 ? (
                      data[section].map((item, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{item}</td>
                          <td>
                            <Button
                              variant="outline-warning"
                              size="sm"
                              className="me-2"
                              onClick={() => handleEdit(section, index)}
                            >
                              <FaEdit />
                            </Button>
                            <Button
                              variant="outline-danger"
                              size="sm"
                              onClick={() => handleDelete(section, index)}
                            >
                              <FaTrash />
                            </Button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="3" className="text-center">
                          No {section.toLowerCase()}s added yet.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Tab>
            ))}
          </Tabs>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default AdminMasterPage;
